export default __webpack_public_path__ + "static/media/19.1a5203b2.png";